import $ from 'jquery';
import hcSticky from 'hc-sticky';

// eslint-disable-next-line no-undef
const object = gralObject;

$('.recipe-info__list li').each(function () {
    const $this = $(this);
    let str = $this.text();
    const matches = str.match(/\d+/g);

    if (matches !== null) {
        str = str.replace(matches[0], `<strong>${matches[0]}</strong>`);
    }

    if ($this.find('a').length) {
        $this.find('a').html(str);
    } else {
        $this.html(str);
    }
});

$('.recipes-autocomplete')
    .autocomplete({
        minLength: 3,
        source: function (request, response) {
            $.ajax({
                url: object.ajaxUrl,
                type: 'POST',
                dataType: 'JSON',
                data: {
                    nonce: object.nonce,
                    action: 'gral_get_recipes',
                    keyword: request.term,
                },
                success: function (res) {
                    response(res.data.data);
                },
            });
        },
        search: function (event) {
            $(event.target)
                .parents('.filter__search')
                .find('button[type=submit]')
                .hide();
            $(event.target)
                .parents('.filter__search')
                .find('.gral-loader')
                .show();
        },
        open: function (event) {
            $(event.target)
                .parents('.filter__search')
                .find('button[type=submit]')
                .show();
            $(event.target)
                .parents('.filter__search')
                .find('.gral-loader')
                .hide();
            $(event.target).addClass('autocomplete-active');
        },
        close: function (event) {
            $(event.target).removeClass('autocomplete-active');
        },
        create: function () {
            $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                return $('<li>')
                    .append(
                        `<a href="${item.url}" class="res-product">${
                            item.thumbnail
                                ? `<img src="${item.thumbnail}" alt="${item.name}">`
                                : ''
                        }${item.title}</a>`
                    )
                    .appendTo(ul);
            };
        },
    })
    .focus(function () {
        $(this).data('uiAutocomplete').search($(this).val());
    });

document.addEventListener('DOMContentLoaded', function () {
    new hcSticky('.ingredients-wrapper', {
        top: $('#wpadminbar').length ? $('#wpadminbar').height() + 130 : 130,
        responsive: {
            765: {
                disable: true,
            },
        },
    });
});
